import { L10n } from '../L10n/L10n';
import { FlowBaseInfo, FlowBasicInfo } from '../models/FlowInfo';
import { IErrorItem, MultipleItemResult } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import {
  ContentActionNotification,
  IMultipleResultNotificationOptions,
  MultipleResultNotificationOptions,
} from './ContentActionNotification';
import { FlowErrors } from './FlowErrors';

export class RunFlowOnOutputStepsNotification {

  public static $inject = [
    '$state',
    '$translate',
    'ContentActionNotification',
    'FlowErrors'];

  constructor(
    private $state: ng.ui.IStateService,
    private $translate: ng.translate.ITranslateService,
    private contentActionNotification: ContentActionNotification,
    private flowErrors: FlowErrors
  ) { }

  public notify(
    result: IResult,
    flow: FlowBasicInfo,
    outputCount: number) {

    let flowSet = Set.singletonForIdItem(flow);
    const notification: IMultipleResultNotificationOptions = MultipleResultNotificationOptions.create(
      new MultipleItemResult(flowSet, result),
      {
        describeSuccessSummary: () => {
          return this.$translate.instant('runFlowsOnOutputStepsSuccess',
            { FLOW_NAME: L10n.elideIfLong(flow.name), ITEM_COUNT: outputCount }, L10n.Interpolations.Count);
        },
        describeErrorSummary: () => {
          return this.$translate.instant('runFlowsOnOutputStepsError', { FLOW_NAME: L10n.elideIfLong(flow.name) });
        },
        describeErrorDetail: (errorItem: IErrorItem<FlowBaseInfo>) => {
          return {
            itemName: errorItem.item ? errorItem.item.name : L10n.elideIfLong(flow.name),
            itemUrl: this.$state.href('main.site.content.site.flows', { id: errorItem.item ? errorItem.item.id : flow.id}),
            errorMessage: this.flowErrors.errorMessageFor(errorItem)
          };
        }
      }
    );

    this.contentActionNotification.notify(notification);
  }

}

Module.instance().service('RunFlowOnOutputStepsNotification', RunFlowOnOutputStepsNotification);
